var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.111 12.189H5a.3.3 0 0 1-.3-.3V5a.3.3 0 0 1 .3-.3h5.111a.3.3 0 0 1 .3.3v6.889a.3.3 0 0 1-.3.3zm0 7.111H5a.3.3 0 0 1-.3-.3v-3.333a.3.3 0 0 1 .3-.3h5.111a.3.3 0 0 1 .3.3V19a.3.3 0 0 1-.3.3zm8.889 0h-5.111a.3.3 0 0 1-.3-.3v-6.889a.3.3 0 0 1 .3-.3H19a.3.3 0 0 1 .3.3V19a.3.3 0 0 1-.3.3zM13.589 8.333V5a.3.3 0 0 1 .3-.3H19a.3.3 0 0 1 .3.3v3.333a.3.3 0 0 1-.3.3h-5.111a.3.3 0 0 1-.3-.3z",
    stroke: "#696871",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e91c2f99515f33b9702d922d9caad444.svg";
export { ForwardRef as ReactComponent };